import { Trip } from 'src/types/trips/Trips';
import apiFetch from 'src/core/fetch';
import type { SessionData } from '../types';

/**
 * Gmb-next DropdownDS22 prevents storing value as number, and subsequently
 * converts the value between types. Add runtime checks due to low confidence
 * in the types when writing sessionStorage.
 */
const ensureNumber = (input?: number | string): number | undefined => {
  if (input === null || input === undefined) {
    return undefined;
  }
  const num = Number(input);
  if (Number.isNaN(num)) {
    return undefined;
  }
  return num;
};

const bookInstabook = async (data: SessionData): Promise<Trip> => {
  const { formData:
    { guests: {
      adults, seniors, children, infants,
    }, departureTime, ownerMessage, selectedOccasion } } = data;

  const response = await apiFetch(
    `/instabook/trips/${data.availabilityId}/book/`,
    {
      method: 'PATCH',
      body: JSON.stringify({
        adults,
        seniors,
        children,
        infants,
        pickup_time: departureTime,
        inquiry_comment: ownerMessage,
        occasions: [ensureNumber(selectedOccasion)],
      }),
    },
  );
  if (!response.ok) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw response;
  }
  const trip = await response.json();
  return trip;
};

export default bookInstabook;
